import { makeRequest } from 'cityads-v3/utils/apiUtils';

export const SET_SHOW_HEADER = "header/SET_SHOW_HEADER";
export const SET_SHOW_FOOTER = "header/SET_SHOW_FOOTER";

export const SET_SLOGAN = "header/SET_SLOGAN";
export const SET_BACKLINK = "header/SET_BACKLINK";
export const SET_CURRENT_TITLE = "header/SET_CURRENT_TITLE";
export const SET_MENU = "header/SET_MENU";
export const SET_MENU_SHOW = "header/SET_MENU_SHOW";
export const SET_MENU_VALUE = "header/SET_MENU_VALUE";

export const LOAD_EVENT_INFO = "header/LOAD_EVENT_INFO";
export const LOAD_EVENT_INFO_SUCCESS = "header/LOAD_EVENT_INFO_SUCCESS";
export const LOAD_EVENT_INFO_FAIL = "header/LOAD_EVENT_INFO_FAIL";

export function setShowHeader(showHeader) {
  return {
    type: SET_SHOW_HEADER,
    showHeader
  }
}

export function setShowFooter(showFooter) {
  return {
    type: SET_SHOW_FOOTER,
    showFooter
  }
}

export function setSlogan(slogan = null) {
  return {
    type: SET_SLOGAN,
    slogan
  }
}

export function setBacklink(link = null, text = null) {
  return {
    type: SET_BACKLINK,
    link,
    text
  }
}

export function setCurrentTitle(title = null) {
  return {
    type: SET_CURRENT_TITLE,
    title
  }
}

export function setMenu(menu = []) {
  return {
    type: SET_MENU,
    menu
  }
}

export function setMenuShow(menuShow) {
  return {
    type: SET_MENU_SHOW,
    menuShow
  }
}

export function setMenuValue(menuValue) {
  return {
    type: SET_MENU_VALUE,
    menuValue
  }
}

export function loadEventInfo({url, id}) {
  return makeRequest(url, {
    types: [LOAD_EVENT_INFO, LOAD_EVENT_INFO_SUCCESS, LOAD_EVENT_INFO_FAIL],
    id
  });
}
